// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gD3A9sCFLBEbrsaxs7ao {
    margin-top: 32px;

    && {
        padding: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Telehealth/TelehealthMessageCard/TelehealthMessageCard.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;IAEhB;QACI,aAAa;IACjB;AACJ","sourcesContent":[".messageCard {\n    margin-top: 32px;\n\n    && {\n        padding: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageCard": `gD3A9sCFLBEbrsaxs7ao`
};
export default ___CSS_LOADER_EXPORT___;
